import { type ReduxState } from "@dashboard/types/reduxState";

import { RestaurantSelectedAction } from "./restaurantReducer";

// Actions for showing errors
export type TermsAcceptanceActions =
  | RestaurantSelectedAction // we listen to this action to reset the terms acceptance state when a new restaurant is selected
  | { type: "TERMS_ACCEPTANCE_FETCHED"; acceptanceStatus: boolean } // When the terms acceptance status is fetched from the API.
  | { type: "SET_TERMS_ACCEPTED"; acceptanceStatus: boolean }; // When the terms acceptance status is set.

export const termsAcceptanceReducer: (
  state: ReduxState["termsAcceptance"] | undefined,
  action: TermsAcceptanceActions
) => ReduxState["termsAcceptance"] = (
  state: ReduxState["termsAcceptance"] = {
    termsAcceptanceStatusLoading: true,
    termsAcceptanceStatus: null,
  },
  action: TermsAcceptanceActions
) => {
  switch (action.type) {
    case "TERMS_ACCEPTANCE_FETCHED":
      // When the terms acceptance status is fetched from the API.
      return {
        ...state,
        termsAcceptanceStatusLoading: false,
        termsAcceptanceStatus: action.acceptanceStatus,
      } as ReduxState["termsAcceptance"];
    case "SET_TERMS_ACCEPTED":
      // When the terms acceptance status is set.
      return {
        ...state,
        termsAcceptanceStatusLoading: false,
        termsAcceptanceStatus: action.acceptanceStatus,
      } as ReduxState["termsAcceptance"];
    case "RESTAURANT_SELECTED":
      // When the current restaurant is selected / updated from the header or initial laod.
      // If no restaurant exists, this is also handled here.
      return {
        ...state,
        termsAcceptanceStatusLoading: true,
        termsAcceptanceStatus: null,
      } as ReduxState["termsAcceptance"];
    default:
      return state;
  }
};
